.root {
  margin-left: 40px;
}
.root .ingredient {
  display: inline;
  padding: 0 4px;
  border-radius: 2px;
  background-color: var(--ingredient-color-back);
  color: var(--ingredient-color-text);
}
.root .ingredient .icon {
  color: var(--ingredient-color-icon);
}
.root .ingredient .amount {
  margin-left: 8px;
  padding: 0 4px;
  background-color: var(--ingredient-color-match);
}

:global(.RichEditor-styleButton) {
  color: var(--ink-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlY2lwZUVkaXRvci5zYXNzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlBO0VBQ0U7O0FBQ0E7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0U7O0FBQ0Y7RUFDRTtFQUNBO0VBQ0E7OztBQUdOO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyJAdXNlIFwic2Fzczpjb2xvclwiXG5cbkB1c2UgJy4uLy4uL3VpL3Nob3AnXG5cbi5yb290XG4gIG1hcmdpbi1sZWZ0OiA0MHB4XG4gIC5pbmdyZWRpZW50XG4gICAgZGlzcGxheTogaW5saW5lXG4gICAgcGFkZGluZzogMCA0cHhcbiAgICBib3JkZXItcmFkaXVzOiAycHhcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1pbmdyZWRpZW50LWNvbG9yLWJhY2spXG4gICAgY29sb3I6IHZhcigtLWluZ3JlZGllbnQtY29sb3ItdGV4dClcbiAgICAuaWNvblxuICAgICAgY29sb3I6IHZhcigtLWluZ3JlZGllbnQtY29sb3ItaWNvbilcbiAgICAuYW1vdW50XG4gICAgICBtYXJnaW4tbGVmdDogOHB4XG4gICAgICBwYWRkaW5nOiAwIDRweFxuICAgICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0taW5ncmVkaWVudC1jb2xvci1tYXRjaClcblxuXG46Z2xvYmFsKC5SaWNoRWRpdG9yLXN0eWxlQnV0dG9uKVxuICBjb2xvcjogdmFyKC0taW5rLWNvbG9yKVxuIl19 */